export class ConveyanceCommunityARBankResultDto {
    communityName: string;
    bankName: string;
}
